// Papéis de quem usa a conta (E9), o que cada um pode fazer e a mensagem do
// convite que o titular manda pelo WhatsApp.
import { dataDoMomento } from './formato.js';

export const PAPEIS = {
  titular: { nome: 'Titular', faz: 'faz tudo (lança, mexe nas placas e nos dados da empresa e convida pessoas)' },
  escritorio: { nome: 'Escritório', faz: 'lança e edita tudo, menos placas e dados da empresa' },
  contador: { nome: 'Contador', faz: 'só consulta (vê tudo, mas não lança nem altera)' },
};

export function rotuloPapel(papel) {
  return PAPEIS[papel]?.nome ?? papel;
}

// A mensagem que o titular manda para a pessoa convidada.
export function mensagemDoConvite({ empresa, email, papel, expira, endereco }) {
  return [
    `Olá! ${empresa} convidou você para usar o HSA Frota como ${rotuloPapel(papel).toLowerCase()}: ${PAPEIS[papel]?.faz ?? ''}.`,
    '',
    `1. Abra ${endereco}`,
    `2. Entre com o e-mail ${email} (o código de entrada chega nesse e-mail)`,
    '3. Toque em "Aceitar o convite"',
    '',
    `O convite vale até ${dataDoMomento(expira)}.`,
  ].join('\n');
}
